import _classPrivateFieldInitSpec from "/var/www/html/node_modules/@babel/runtime/helpers/esm/classPrivateFieldInitSpec.js";
import _defineProperty from "/var/www/html/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _classPrivateFieldGet from "/var/www/html/node_modules/@babel/runtime/helpers/esm/classPrivateFieldGet2.js";
import "core-js/modules/esnext.iterator.map.js";
import JsonMappedModel from "./helpers/JsonMappedModel";
import CountryState from "./countryState/CountryState";
import City from "./city/City";
import Country from "./country/Country";
var _attributes = /*#__PURE__*/new WeakMap();
export default class Client extends JsonMappedModel {
  constructor(data) {
    super(data);
    _classPrivateFieldInitSpec(this, _attributes, {
      [Client.id_attribute_name]: null,
      [Client.full_name_attribute_name]: null,
      [Client.phone_attribute_name]: null,
      [Client.address_attribute_name]: null,
      [Client.postal_code_attribute_name]: null,
      [Client.other_city_attribute_name]: null,
      [Client.city_attribute_name]: City,
      [Client.email_attribute_name]: null,
      [Client.region_attribute_name]: CountryState,
      [Client.other_region_attribute_name]: null,
      [Client.ip_address_attribute_name]: null,
      [Client.country_attribute_name]: Country
    });
    this.map(data, _classPrivateFieldGet(_attributes, this));
  }
  static getPostalCodeAttributeName() {
    return Client.postal_code_attribute_name;
  }
  static getFullNameAttributeName() {
    return Client.full_name_attribute_name;
  }
  static getAddressAttributeName() {
    return Client.address_attribute_name;
  }
  static getIpAddressAttributeName() {
    return Client.ip_address_attribute_name;
  }
  static getCountryAttributeName() {
    return Client.country_attribute_name;
  }
  static getEmailAttributeName() {
    return Client.email_attribute_name;
  }
  static getPhoneAttributeName() {
    return Client.phone_attribute_name;
  }
  static getRegionAttributeName() {
    return Client.region_attribute_name;
  }
  static getOtherRegionAttributeName() {
    return Client.other_region_attribute_name;
  }
  static getCityAttributeName() {
    return Client.city_attribute_name;
  }
  static getOtherCityAttributeName() {
    return Client.other_city_attribute_name;
  }
  getFullName() {
    return this.getAttribute(Client.full_name_attribute_name);
  }
  getCountry() {
    return this.getAttribute(Client.country_attribute_name);
  }
  getPhone() {
    return this.getAttribute(Client.phone_attribute_name);
  }
  getAddress() {
    return this.getAttribute(Client.address_attribute_name);
  }
  getRegion() {
    return this.getAttribute(Client.region_attribute_name);
  }
  getRegionNativeName() {
    let region = this.getRegion();
    return region instanceof CountryState ? region.getNativeName() : null;
  }
  getRegionName() {
    let region = this.getRegion();
    return region instanceof CountryState ? region.getName() : null;
  }
  getCustomRegionName() {
    return this.getAttribute(Client.other_region_attribute_name);
  }
  getCity() {
    return this.getAttribute(Client.city_attribute_name);
  }
  getCityNativeName() {
    let city = this.getCity();
    return city instanceof City ? city.getNativeName() : null;
  }
  getCityName() {
    let city = this.getCity();
    return city instanceof City ? city.getName() : null;
  }
  getCityCustomName() {
    return this.getAttribute(Client.other_city_attribute_name);
  }
}
_defineProperty(Client, "id_attribute_name", 'client_id');
_defineProperty(Client, "full_name_attribute_name", 'client_full_name');
_defineProperty(Client, "phone_attribute_name", 'client_phone');
_defineProperty(Client, "address_attribute_name", 'client_address');
_defineProperty(Client, "postal_code_attribute_name", 'client_postal_code');
_defineProperty(Client, "other_city_attribute_name", 'client_other_city');
_defineProperty(Client, "city_attribute_name", 'city');
_defineProperty(Client, "email_attribute_name", 'client_email');
_defineProperty(Client, "region_attribute_name", 'client_region');
_defineProperty(Client, "other_region_attribute_name", 'client_other_region');
_defineProperty(Client, "ip_address_attribute_name", 'ip_address');
_defineProperty(Client, "country_attribute_name", 'country');